import { render, staticRenderFns } from "./GovernmentIssuedId.vue?vue&type=template&id=2fcb8b8c&scoped=true&"
import script from "./GovernmentIssuedId.vue?vue&type=script&lang=js&"
export * from "./GovernmentIssuedId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb8b8c",
  null
  
)

export default component.exports